import { render, staticRenderFns } from "./MultiMerchantBanner.vue?vue&type=template&id=620eafba&scoped=true"
import script from "./MultiMerchantBanner.vue?vue&type=script&lang=js"
export * from "./MultiMerchantBanner.vue?vue&type=script&lang=js"
import style0 from "./MultiMerchantBanner.vue?vue&type=style&index=0&id=620eafba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620eafba",
  null
  
)

export default component.exports